<template>
  <div class="main">
      <main>
          <div class="head">
            <div class="head1">
                <h1>哲学</h1>
                <p class="type">本科>哲学>哲学类</p>
                <div><span>专业代码：020101</span></div>
            </div>
          </div>
          <div class="content flex" style="align-items: flex-start;">
            <div class="left">
              <el-tabs class="tabs" v-model="activeName" type="card" @tab-click="handleClick">
               <el-tab-pane label="专业简介" name="first">
                  <div class="title">选考建议</div>
                    <div class="introduction">
                      <div >3+3省份：不限<br>
                      3+1+2省份：首选不限，再选政治/化学/地理/生物</div>
                    </div>
                    <div class="title">专业解释</div>
                      <div class="introduction">
                        <div >3+3省份：不限<br>
                        3+1+2省份：首选不限，再选政治/化学/地理/生物</div>
                      </div><div class="title">学习内容</div>
                    <div class="introduction">
                      <div >3+3省份：不限<br>
                      3+1+2省份：首选不限，再选政治/化学/地理/生物</div>
                    </div><div class="title">就业方向</div>
                    <div class="introduction">
                      <div >3+3省份：不限<br>
                      3+1+2省份：首选不限，再选政治/化学/地理/生物</div>
                    </div>
                    <div class="more">更多内容></div>
                    <div class="ratio flex">
                        <div class="wenli">
                          <div class="title">文理比例</div>
                          <div class="ratio1 flex">
                              <div>
                                <p>文</p>
                                <div>85%</div>
                              </div>
                              <el-progress style="width: 220px;" :percentage="50" :show-text="false"></el-progress>
                              <div>
                                <p style="background-color: #FFF5DA;color: #FDCB48;">文</p>
                                <div>85%</div>
                              </div>
                          </div>
                        </div>
                        <div class="wenli">
                          <div class="title">文理比例</div>
                          <div class="ratio2 flex">
                              <el-progress :width="81" type="circle" :percentage="25"></el-progress>
                              <div>
                                <p style="margin-bottom: 28px;"><span class="circle"></span><span>男：60%</span></p>
                                 <p><span class="circle1"></span><span>男：60%</span></p>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div class="year">
 <div class="title" style="width: 130px;">近三年就业率</div>
 <div class="ratio3 flex">
<div>
  <el-progress :width="81" type="circle" :percentage="25"></el-progress>
  <p>85%~90%</p>
</div>
<div>
  <el-progress :width="81" type="circle" :percentage="25"></el-progress>
  <p>85%~90%</p>
</div>
<div>
  <el-progress :width="81" type="circle" :percentage="25"></el-progress>
  <p>85%~90%</p>
</div>
 </div>
                    </div>
               </el-tab-pane>
               <el-tab-pane label="开设院校" name="second">专科院校</el-tab-pane>
              </el-tabs>
            </div>

            <!-- 推荐高校 -->
            <div class="recommend">
              <sidebar></sidebar>
            </div>
          </div>
      </main>
  </div>
</template>

<script>
  import sidebar from '../../components/sidebar.vue'
export default {
  data () {
    return {
      activeName:"first"
    }
  },
  created() {

  },
  components:{
    sidebar
  }
}
</script>

<style scoped lang="scss">
  .recommend{
    margin-left: 34px;
  }
  .list{
    // border: 1px solid #EDEDED;
    .name img{
      width: 20px;height: 20px;vertical-align: middle;
    }
    ul{
      margin-top: 30px;
    }
    li{
      width: 100%;
      margin-bottom: 23px;
      text-align: left;
    }
    .hot{
      color: #FFA200;
      margin-left: 120px;
    }
    .rank{
      width: 20px;
      height: 20px;
      background: #FF0000;
      display: inline-block;
      color: #FFFFFF;
      line-height: 20px;
      text-align: center;
    }
    .rank1{
      background: #FF7F7F;
    }
    .rank2{
      background: #FFCCCC;
    }
    .rank3{
      background: #F2F2F2;
    }
  }
  .ratio3{
    width: 784px;
    height: 151px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05);
    border-radius: 10px;
    margin: 20px 2px;
    justify-content: space-around;
  }
  .ratio{
    margin-top: 45px;
    justify-content: space-between;
    .ratio2{
      width: 364px;
      height: 113px;
      background: #FFFFFF;
      margin: 20px 2px;
      box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05); justify-content: space-around;
      border-radius: 10px;
      .circle{
        display: inline-block;
        margin-right: 6px;
        width: 10px;
        height: 10px;
        background: #19CACA;
        border-radius: 50%;
      }
      .circle1{
        display: inline-block;
        margin-right: 6px;
        width: 10px;
        height: 10px;border-radius: 50%;
        background-color: #FDCB48;
      }
    }
    .ratio1{
        width: 364px;
        height: 113px;
        background: #FFFFFF;
        margin: 20px 2px;
        box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05); justify-content: space-around;
        border-radius: 10px;
       p{
          width: 50px;
          height: 50px;
          background: #D1F4F4;
          border-radius: 50%;
          line-height: 50px;margin-bottom: 8px;color: #19CACA;
        }
    }
    &>div{
      flex: 1;
    }
  }
  .more{
    width: 142px;
    height: 40px;
    background: #E8FAFA;
    border-radius: 20px;color: #19CACA;text-align: center;line-height: 40px;display: block;margin: 0 auto;
  }
  .introduction{
    line-height: 30px;
      text-align: left;margin: 20px 0 30px 0;
  }
  .title{
    color: #333333;font-weight: bold;
  }
  .left{
    width: 845px;
  }
  .tabs{
    margin-top: 28px;
  }
.head{
  width: 1200px;
  height: 210px;
  background: url(../../assets/school/bg3.png)no-repeat;
  color: #FFFFFF;overflow: hidden;text-align: left;
  .type{
    margin: 20px auto;font-size: 18px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #FFFFFF;
  }
  h1{
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    width: 468px;
    padding-bottom: 17px;
    border-bottom: 1px solid #FFFFFF;
  }
  .head1{
    margin: 49px 0 0 24px;
  }
}
 .main{
    width: 1200px;
     min-height: 1500px;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/specialty/openSchool.vue